<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import PublicLayout from './components/PublicLayout.vue';
import AdminLayout from './components/AdminLayout.vue';

const route = useRoute();
const layout = computed(() => route.path.startsWith('/admin') ? AdminLayout : PublicLayout);
</script>
